import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

// attach Bearer + active branch as fallback (in case cookies are blocked cross-site)
http.interceptors.request.use((config) => {
  const t = localStorage.getItem("token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  // auto-attach ?branch= if the request doesn't already specify one and we have an active branch
  const activeBranch = localStorage.getItem("activeBranchId");
  if (activeBranch && !config.params?.branch && !(typeof config.url === "string" && config.url.includes("branch="))) {
    // Skip auto-attaching for endpoints that must not be scoped by branch
    const noBranch = ["/branches", "/currencies", "/customers", "/settings/", "/public/", "/auth/",
                       "/rate-history", "/margin-alerts", "/files/", "/reports/export"];
    const skip = noBranch.some((p) => (config.url || "").includes(p));
    if (!skip) {
      config.params = { ...(config.params || {}), branch: activeBranch };
    }
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Terjadi kesalahan. Silakan coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fmtIDR = (n) =>
  new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", maximumFractionDigits: 0 }).format(n || 0);

export const fmtNum = (n, d = 2) =>
  new Intl.NumberFormat("id-ID", { minimumFractionDigits: d, maximumFractionDigits: d }).format(n || 0);
